<template>
  <div @click="hidemap">
    <div id="liste-balises">
      <div
        v-for="balise in balisesdatas.data"
        :key="balise.id"
        @click="handleClickMenu(balise)"
      >
        {{ balise.name.toUpperCase() }}
      </div>
    </div>
    <!-- On utilise le custom event envoyé par le composant. à noter qu'on transforme le camel case en kebab case, c'est une reccomandation de vue js voir le doc à ce sujet -->
    <div v-for="balise in balisesdatas.data" :key="balise.id">
      <Balise
        v-if="balise.id === activeBalise.id"
        :name="balise.name"
        :idBalise="balise.id"
        @show-map="handleClickBalise"
      />
    </div>
    <Forecast @show-site-map="handleClickBalise" v-if="display"></Forecast>
    <Map
      :coords="mapCoordinates"
      :code_ffvl="code_ffvl"
      v-if="isDisplayMap"
      @click.stop
      @dblclick="isDisplayMap = false"
    ></Map>
  </div>
</template>

<script>
const filterForecast = (forecast, shift = 1) => {
  //filtrage des données de forecast pour ne prendre que celles du jour souhaité
  //shift représente la durée de prévision en jour. exemple, 2 signifie previ de demain, 3 apres demain etc ...
  const filterForecast = {};
  const arrayProps = Object.getOwnPropertyNames(forecast);
  for (let prop of arrayProps) {
    filterForecast[prop] = forecast[prop].filter((value, index) => {
      return index >= (shift - 1) * 24 && index <= shift * 24 - 1;
    });
  }
  return filterForecast;
};

import Balise from "./components/windBalise";
import Forecast from "./components/windForecast";
import balisesdatas from "./assets/balises.js";
import Map from "./components/map.vue";
export default {
  name: "App",
  components: { Balise, Forecast, Map },
  data() {
    return {
      balisesdatas: balisesdatas,
      title: "My wind app",
      display: true,
      mapCoordinates: [45, 0],
      code_ffvl: "",
      isDisplayMap: false,
      activeBalise: balisesdatas.data[0],
    };
  },
  methods: {
    handleClickBalise(coords) {
      console.log(
        "lat",
        coords.lat,
        " lon",
        coords.lon,
        "code ffvl",
        coords.code_ffvl
      );
      this.mapCoordinates = [coords.lat, coords.lon];
      this.code_ffvl = coords.code_ffvl;
      this.isDisplayMap = true;
    },
    handleClickMenu(balise) {
      this.activeBalise = { id: balise.id, name: balise.name };
    },
    hidemap() {
      this.isDisplayMap = false;
    },
  },

  mounted() {},
  computed: {},
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

h1 {
  border-bottom: 1px solid #ddd;
  display: inline-block;
  padding-bottom: 10px;
}

/* @media  screen and (min-width:850px) {
  #liste-balises{
    grid-template-columns: repeat(8,1fr);
  }
} */
#liste-balises {
  display: grid;
  /* justify-content: center; */
  /* grid-template-rows: 10vh 10vh; */
  grid-auto-rows: 4em;
  justify-content: center;
  margin: auto;
  grid-template-columns: repeat(8, 1fr);
}
@media screen and (max-width: 850px) {
  #liste-balises {
    grid-template-columns: repeat(1, 1fr);
  }
}

#liste-balises div {
  /* display: inline-block; */
  padding: 10px;
  background-color: darkcyan;
  font-size: medium;
  margin: 2px;
  color: antiquewhite;
  /* width: 110px; */
  text-align: center;
}

#liste-balises div:hover {
  background-color: aqua;
  color: chocolate;
}
</style>
